export const getMenuItems = () => {
  // Items do menu ação
  return [
    { key: "1", label: "Excluir" },
    { key: "2", label: "Alterar Status" },
  ];
};
